import { render } from "./P3PNodePicker.vue?vue&type=template&id=8a5d6856"
import script from "./P3PNodePicker.vue?vue&type=script&lang=js"
export * from "./P3PNodePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__